// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainAfter, addToChainBefore } from "@insite/client-framework/HandlerCreator";
import { chain, GetUnfilteredProducts, PopulateApiParameter } from "@insite/client-framework/Store/Pages/ProductList/Handlers/DisplayProducts";

export const XngPopulateApiParameter: typeof PopulateApiParameter = props => {
    props.apiParameter = {
        ...props.apiParameter,
    };

    if (props.apiParameter.categoryId) {
        if ((props.parameter as any)?.notFromCategory) {
            props.apiParameter.includeAttributes!.push("notFromCategory");
        }

        if ((props.parameter as any)?.includeProductsInSubCategories) {
            (props.apiParameter as any).includeProductsInSubCategories = !!(props.parameter as any)
                ?.includeProductsInSubCategories;
        }
    }
    props.apiParameter.expand = [...(props.apiParameter.expand || []), "properties"];
};

/**
 * XNG-Changes
 * We should remove includeProductsInSubCategories from ApiParameter because this option need CategoryId
 * and GetUnfilteredProducts remove CategoryId from ApiParameter
 */
export const XngGetUnfilteredProducts: any = (props: any) => {
    if (!props.result.productFilters.pageCategoryId) {
        const apiParameter = { ...props.apiParameter };
        if (props.apiParameter.includeProductsInSubCategories) {
            delete apiParameter.includeProductsInSubCategories;
        }
        if (props.apiParameter.restrictAttributesToCategory) {
            delete apiParameter.restrictAttributesToCategory;
        }
        props.apiParameter = {
            ...apiParameter,
        };
    }
};


addToChainAfter(chain, PopulateApiParameter, XngPopulateApiParameter);
addToChainBefore(chain, GetUnfilteredProducts, XngGetUnfilteredProducts);

